var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3023",
    "data-name": "Group 3023",
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.628,
    height: 53.327,
    viewBox: "0 0 65.628 53.327",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line_1021",
    "data-name": "Line 1021",
    d: "M31.251,32.367a1.111,1.111,0,0,1-.788-.327L-1.173.4a1.115,1.115,0,0,1,0-1.577,1.115,1.115,0,0,1,1.577,0L32.039,30.464a1.115,1.115,0,0,1-.788,1.9Z",
    transform: "translate(17.188 17.189)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3422",
    "data-name": "Path 3422",
    d: "M6.6,25.752a1.114,1.114,0,0,1,.226.023c.06.012,1.487.309,3.092.767,3.09.881,4.01,1.546,4.433,1.97a4.318,4.318,0,1,1-6.106,6.106c-.423-.423-1.088-1.344-1.97-4.433-.458-1.606-.755-3.032-.767-3.092A1.115,1.115,0,0,1,6.6,25.752Zm4.7,7.9a2.088,2.088,0,0,0,1.476-3.565c-.1-.1-.717-.617-3.468-1.4-.423-.121-.836-.23-1.212-.326.1.38.207.8.329,1.225.783,2.741,1.3,3.36,1.4,3.456A2.074,2.074,0,0,0,11.3,33.654Z",
    transform: "translate(0.789 -19.478)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3423",
    "data-name": "Path 3423",
    d: "M22.248,37.31h0a4.319,4.319,0,0,1-4.221-3.427c-.124-.585-.179-1.719.768-4.789.492-1.6,1.022-2.953,1.045-3.01a1.115,1.115,0,0,1,1.823-.385c.043.043,1.077,1.071,2.172,2.331,2.108,2.425,2.516,3.485,2.639,4.07a4.318,4.318,0,0,1-3.332,5.116A4.341,4.341,0,0,1,22.248,37.31Zm-.934-8.752c-.127.371-.262.781-.393,1.206-.84,2.724-.742,3.526-.714,3.659a2.084,2.084,0,0,0,2.474,1.612,2.088,2.088,0,0,0,1.611-2.474c-.028-.134-.264-.908-2.141-3.068C21.864,29.16,21.577,28.843,21.314,28.558Z",
    transform: "translate(1.075 -19.487)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3424",
    "data-name": "Path 3424",
    d: "M30.012,45.074h0a4.319,4.319,0,0,1-4.221-3.427c-.124-.586-.178-1.72.769-4.789.492-1.6,1.022-2.953,1.044-3.01a1.115,1.115,0,0,1,1.824-.385c.043.043,1.077,1.071,2.172,2.331,2.108,2.425,2.516,3.484,2.639,4.07a4.318,4.318,0,0,1-3.332,5.116A4.343,4.343,0,0,1,30.012,45.074Zm-.933-8.752c-.127.371-.262.781-.392,1.205-.84,2.724-.742,3.526-.714,3.659A2.084,2.084,0,0,0,30.446,42.8a2.088,2.088,0,0,0,1.611-2.473c-.028-.134-.264-.909-2.141-3.069C29.628,36.924,29.342,36.607,29.079,36.322Z",
    transform: "translate(1.253 -19.308)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3425",
    "data-name": "Path 3425",
    d: "M37.777,52.838h0a4.319,4.319,0,0,1-4.221-3.427c-.124-.585-.178-1.719.769-4.789.492-1.6,1.022-2.953,1.045-3.01a1.115,1.115,0,0,1,1.823-.385c.043.043,1.077,1.071,2.172,2.331,2.107,2.425,2.515,3.484,2.639,4.07a4.318,4.318,0,0,1-3.332,5.116A4.343,4.343,0,0,1,37.777,52.838Zm-.933-8.751c-.127.371-.262.781-.393,1.206-.84,2.724-.743,3.525-.714,3.658a2.084,2.084,0,0,0,2.474,1.612,2.088,2.088,0,0,0,1.611-2.474c-.028-.133-.263-.906-2.132-3.058C37.4,44.7,37.11,44.375,36.844,44.087Z",
    transform: "translate(1.431 -19.13)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3426",
    "data-name": "Path 3426",
    d: "M45.54,60.6h0a4.318,4.318,0,0,1-4.22-3.426c-.124-.585-.178-1.719.769-4.789.492-1.6,1.022-2.953,1.045-3.01a1.115,1.115,0,0,1,1.824-.385c.043.043,1.077,1.071,2.172,2.331,2.107,2.425,2.515,3.484,2.639,4.07a4.316,4.316,0,0,1-3.333,5.115A4.337,4.337,0,0,1,45.54,60.6Zm-.931-8.751c-.127.371-.262.781-.393,1.206-.84,2.725-.743,3.526-.714,3.659a2.1,2.1,0,0,0,2.038,1.657h0a2.1,2.1,0,0,0,.435-.046,2.086,2.086,0,0,0,1.611-2.473c-.028-.134-.264-.909-2.14-3.069C45.157,52.452,44.871,52.135,44.608,51.85Z",
    transform: "translate(1.609 -18.951)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3427",
    "data-name": "Path 3427",
    d: "M12.726,46.836a4.343,4.343,0,0,1-.895-.094c-.586-.124-1.645-.532-4.069-2.639-1.26-1.1-2.288-2.129-2.331-2.172a1.115,1.115,0,0,1,.385-1.824c.492-.192,4.867-1.88,7.093-1.88a3.4,3.4,0,0,1,.706.066,4.318,4.318,0,0,1-.888,8.543ZM8.29,41.581c.288.266.609.556.945.847,2.152,1.87,2.924,2.1,3.057,2.132a2.088,2.088,0,1,0,.862-4.086,1.239,1.239,0,0,0-.244-.018A18.883,18.883,0,0,0,8.29,41.581Z",
    transform: "translate(0.78 -19.191)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3428",
    "data-name": "Path 3428",
    d: "M20.491,54.6a4.343,4.343,0,0,1-.895-.094c-.586-.124-1.645-.532-4.069-2.639-1.26-1.1-2.288-2.129-2.331-2.172a1.115,1.115,0,0,1,.385-1.824c.492-.192,4.867-1.88,7.093-1.88a3.4,3.4,0,0,1,.706.066,4.318,4.318,0,0,1-.888,8.543Zm-4.437-5.255c.288.266.609.556.945.848,2.152,1.869,2.924,2.1,3.057,2.132a2.088,2.088,0,1,0,.862-4.086,1.24,1.24,0,0,0-.244-.018A18.864,18.864,0,0,0,16.054,49.346Z",
    transform: "translate(0.958 -19.013)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3429",
    "data-name": "Path 3429",
    d: "M28.255,62.365a4.345,4.345,0,0,1-.895-.094c-.586-.124-1.645-.532-4.069-2.639-1.26-1.1-2.288-2.129-2.331-2.172a1.115,1.115,0,0,1,.385-1.824c.491-.192,4.865-1.88,7.092-1.88a3.4,3.4,0,0,1,.708.067,4.318,4.318,0,0,1-.89,8.542ZM23.818,57.11c.288.266.609.556.945.848,2.152,1.869,2.924,2.1,3.057,2.132A2.088,2.088,0,0,0,28.684,56a1.248,1.248,0,0,0-.247-.018A18.853,18.853,0,0,0,23.818,57.11Z",
    transform: "translate(1.136 -18.835)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3430",
    "data-name": "Path 3430",
    d: "M36.019,70.129a4.34,4.34,0,0,1-.895-.094c-.586-.124-1.645-.532-4.069-2.639-1.26-1.1-2.288-2.129-2.331-2.172a1.115,1.115,0,0,1,.385-1.824c.492-.192,4.867-1.88,7.094-1.88a3.4,3.4,0,0,1,.706.066,4.318,4.318,0,0,1-.889,8.543Zm-4.437-5.255c.288.266.609.556.945.848,2.152,1.869,2.924,2.1,3.057,2.132a2.088,2.088,0,0,0,.862-4.086,1.242,1.242,0,0,0-.245-.018A18.866,18.866,0,0,0,31.582,64.874Z",
    transform: "translate(1.314 -18.656)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Line_1022",
    "data-name": "Line 1022",
    d: "M2.749,3.864a1.111,1.111,0,0,1-.788-.327L-1.173.4a1.115,1.115,0,0,1,0-1.577,1.115,1.115,0,0,1,1.577,0L3.537,1.961a1.115,1.115,0,0,1-.788,1.9Z",
    transform: "translate(4.64 4.64)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Line_1023",
    "data-name": "Line 1023",
    d: "M5.5,6.618a1.111,1.111,0,0,1-.788-.327L-1.173.4a1.115,1.115,0,0,1,0-1.577,1.115,1.115,0,0,1,1.577,0L6.291,4.715a1.115,1.115,0,0,1-.788,1.9Z",
    transform: "translate(1.5 16.451)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Line_1024",
    "data-name": "Line 1024",
    d: "M5.5,6.618a1.111,1.111,0,0,1-.788-.327L-1.173.4a1.115,1.115,0,0,1,0-1.577,1.115,1.115,0,0,1,1.577,0L6.291,4.715a1.115,1.115,0,0,1-.788,1.9Z",
    transform: "translate(16.451 1.5)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3431",
    "data-name": "Path 3431",
    d: "M55.507,72.009a12.159,12.159,0,0,1-1.485-.091,14.132,14.132,0,0,1-8.064-3.991A1.115,1.115,0,0,1,47.5,66.32a11.844,11.844,0,0,0,6.79,3.384,8.411,8.411,0,0,0,5.555-1.095,3.452,3.452,0,0,0,1.614-4.171,2.851,2.851,0,0,0-2.769-1.77,2.751,2.751,0,0,0-2.231,1.543,2.628,2.628,0,0,0,.2,2.688A1.115,1.115,0,1,1,54.8,68.12a4.98,4.98,0,0,1-.834-2.512,4.88,4.88,0,0,1,.5-2.382,4.969,4.969,0,0,1,9.091.435,5.59,5.59,0,0,1-2.483,6.813A10.224,10.224,0,0,1,55.507,72.009Z",
    transform: "translate(1.709 -18.681)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRye);
export default __webpack_public_path__ + "static/media/Rye.bcb1da5e1e59cf952d36dc0f3071681e.svg";
export { ForwardRef as ReactComponent };